export function dataInRequest(params = {}) {
  return {
    type: '@tipoAreia/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@tipoAreia/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@tipoAreia/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@tipoAreia/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@tipoAreia/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@tipoAreia/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@tipoAreia/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@tipoAreia/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@tipoAreia/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@tipoAreia/RECORD_FILTERING',
    payload: { params },
  };
}
